import { TodoInput, TodoSubtask, TodoTask } from '../models/todo.model';

export abstract class TasksRepository {
  abstract getTodos(): Promise<TodoTask[]>;
  abstract getOpenTodos(): Promise<TodoTask[]>;
  abstract getClosedTodos(): Promise<TodoTask[]>;
  abstract createTodo(input: TodoInput): Promise<void>;
  abstract updateTodo(task: TodoTask, input: TodoInput): Promise<void>;
  abstract completeTodo(task: TodoTask): Promise<void>;
  abstract cancelTodo(task: TodoTask, reason: string | null): Promise<void>;
  abstract reopenTodo(task: TodoTask): Promise<void>;
  abstract deleteTodo(task: TodoTask): Promise<void>;
  abstract deleteClosedTodos(tasks: TodoTask[]): Promise<void>;
  abstract rescheduleTodo(task: TodoTask, scheduledFor: string | null): Promise<void>;
  abstract setSubtaskCompleted(subtask: TodoSubtask, completed: boolean): Promise<void>;
}
